// src/components/Shared/ListView/ListLoading.jsx
import React from "react";
import AppLoader from "../../spiner/AppLoader";

const ListLoading = ({ message = "Loading data..." }) => {
  return (
    <div className="flex min-h-[360px] flex-col items-center justify-center rounded-[14px] border border-slate-200 bg-white p-16 text-center shadow-sm">
      <AppLoader />
      <p className="mt-6 text-[11px] font-extrabold uppercase tracking-[0.22em] text-slate-400">
        Processing Request
      </p>
      <p className="mt-2 text-sm font-medium text-slate-500">
        {message}
      </p>
    </div>
  );
};

export default ListLoading;
